export const UPDATE_BANNER = 'UPDATE_BANNER'
